import React from "react";
import Carousel from "react-multi-carousel";
import { Link } from "react-router-dom";
import "react-multi-carousel/lib/styles.css";
import { useSelector } from "react-redux";

const Categorys = () => {
  const { categorys } = useSelector((state) => state.home);

  const responsive = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 6 },
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 6 },
    tablet: { breakpoint: { max: 1024, min: 768 }, items: 4 },
    mobile: { breakpoint: { max: 768, min: 0 }, items: 2 },
  };

  return (
    <div className="w-11/12 mx-auto relative">
      {/* Section Title */}
      <div className="text-center flex flex-col items-center text-3xl text-slate-600 font-bold">
        <h2>Categorías Más Populares</h2>
        <div className="w-24 h-0.5 bg-green-600 mt-4"></div>
      </div>

      {/* Carousel */}
      <Carousel
        autoPlay
        infinite
        arrows
        responsive={responsive}
        transitionDuration={500}
      >
        {categorys.map((category, index) => (
          <Link
            key={index}
            to={`/products?category=${category.name}`}
            className="flex flex-col items-center m-2 rounded-md relative h-full w-full p-5"
          >
            <div className="flex justify-center items-center h-[150px] w-[150px] p-3">
              <img
                src={category.image}
                alt={category.name}
                className="rounded-md w-auto object-contain max-h-[75%]"
              />
            </div>
            <div className="absolute bottom-10 text-center font-bold">
              <span className="px-4 py-1 bg-gray-200 text-slate-600 rounded-md">
                {category.name}
              </span>
            </div>
          </Link>
        ))}
      </Carousel>
    </div>
  );
};

export default Categorys;
